import {inject, PLATFORM} from 'aurelia-framework';
import {DialogController, DialogService} from 'aurelia-dialog';

@inject(DialogService, DialogController)
export class AddMember {

  groupId: number;

  constructor(public dialog: DialogService, public controller: DialogController) {
  }
  activate(groupId) {
    this.groupId = groupId;
  }
  openOnboard() {
    this.dialog.open({viewModel: PLATFORM.moduleName('resources/pagelayout/content/group/add-member/onboard-member/onboard-member'), model: this.groupId}).then(()=>{ // @ts-ignore
      this.controller.close();});
  }
  openInvite() {
    this.dialog.open({viewModel: PLATFORM.moduleName('resources/pagelayout/content/group/add-member/invite-member/invite-member'), model: this.groupId}).then(()=>{ // @ts-ignore
      this.controller.close();});
  }

}
